import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import OfferBoardLogo from '../../images/Powered-by-OfferBoard.png';
import Graph from '../../images/graph.png';
const noDisplayOfferBoardImage = {
  display: 'none',
};
const AnonDashboardFooter = ({ tenant }) => (
  <div id='dashboard-footer-cta'>
    <div
      id='dashboard-footer-body'
      style={{ backgroundImage: `url(${Graph})` }}
    >
      <div className='max-width-div' style={{ width: '100%' }}>
        <h1>
          Invest with 
          {tenant.customDomain
            ? tenant.name || 'Offerboard'
            : ' ' + tenant.name || 'Offerboard'}
        </h1>
        <div>
          <Link to='/register' className='small button'>
            Join for Free
          </Link>
          <Link to='/login' className='small button'>
            Log In
          </Link>
        </div>
      </div>
    </div>
    <div id='dashboard-footer-logos' className='max-width-div'>
      <Link
        className={
          tenant.logoUrl ? 'tenant-logo offerboard-logo' : 'tenant-logo-hide'
        }
        style={{
          backgroundImage: `url(${tenant.logoUrl})`,
        }}
        target={tenant.marketingSiteUrl ? '_blank' : '_self'}
        to={{ pathname: tenant.marketingSiteUrl || '/' }}
      />
      <Link
        className={
          tenant.logoUrl
            ? 'entoro-ob-logo w-nav-brand'
            : 'entoro-ob-logo w-nav-brand offerboard-logo'
        }
        style={
          tenant.customDomain
            ? noDisplayOfferBoardImage
            : {
                backgroundImage: `url(${OfferBoardLogo})`,
                float: 'right',
                width: '20%',
              }
        }
        to='/'
      />
    </div>
  </div>
);

const mapStateToProps = ({ tenant }) => ({
  tenant,
});

AnonDashboardFooter.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AnonDashboardFooter);



// WEBPACK FOOTER //
// ./src/components/Dashboard/AnonDashboardFooter.js